import { AxiosResponse } from 'axios';
import { Individual } from '../../utils';
import { Request } from '../index';

const viewIndividual = (id: string): Promise<AxiosResponse<Individual>> => {
    return Request.get(`/individuals/${id}`);
};

export default viewIndividual;
